import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import image1 from "../assets/Gemini_Generated_Image_d0gtb4d0gtb4d0gt (2).png";

/**
 * Smart Health Report Section Card
 * 
 * Content card for grid layout (no image, image is in right column)
 */
const SmartHealthReportSection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const features = [
    "Human-friendly layout optimized for printing",
    "Brand-customizable templates and cover pages",
    "Clear visualizations with medical-grade accuracy",
    "Offline accessible without internet",
  ];

  return (
    <Box
      sx={{
        width: "100%",
        padding: {
          xs: "24px",
          sm: "32px",
          md: "40px",
        },
        backgroundColor: "transparent",
        borderRadius: "16px",
        height: "100%",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: "24px", md: "32px" },
        alignItems: "center",
        transition: "all 0.3s ease",
      }}
    >
      {/* Left side - Image */}
      <Box
        sx={{
          flex: { xs: "none", md: "0 0 40%" },
          width: { xs: "100%", md: "auto" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src={image1}
          alt="Smart Health Report"
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: "523px" },
            height: { xs: "330px", md: "396px" },
            objectFit: "cover",
            borderRadius: "16px",
            border: "4px solid rgba(53, 103, 214, 0.25)",
            boxShadow: "0 4px 16px rgba(53, 103, 214, 0.15)",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: "0 8px 24px rgba(53, 103, 214, 0.25)",
              borderColor: "rgba(53, 103, 214, 0.4)",
            },
          }}
        />
      </Box>

      {/* Right side - Content */}
      <Box
        sx={{
          flex: { xs: "none", md: "1" },
          width: { xs: "100%", md: "auto" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "24px", sm: "32px", md: "36px" },
            fontWeight: 700,
            fontFamily: "'Poppins', sans-serif",
            marginBottom: { xs: "16px", md: "20px" },
          }}
        >
          <Box component="span" sx={{ color: "#3567D6" }}>
            Smart Health{" "}
          </Box>
          <Box component="span" sx={{ color: "#1e293b" }}>
            Report
          </Box>
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", sm: "15px", md: "16px" },
            color: "#64748b",
            lineHeight: 1.7,
            marginBottom: { xs: "24px", md: "32px" },
          }}
        >
          Diagnostic labs struggle to engage patients with complex numbers. User-friendly Reports simplify medical test results for users with clear explanations, visualizations, and actionable insights.
        </Typography>

        {/* Features List */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "14px", md: "18px" },
          }}
        >
          {features.map((feature, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <CheckCircleIcon
                sx={{
                  color: "#3567D6",
                  fontSize: { xs: "20px", md: "22px" },
                  marginTop: "2px",
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "14px", md: "15px" },
                  color: "#1e293b",
                  lineHeight: 1.6,
                  fontWeight: 500,
                }}
              >
                {feature}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SmartHealthReportSection;

